module.exports = __webpack_public_path__ + "static/media/icon-status-dispatch.8497fe5a.svg";